<template>
  <div class="mt-2">
    <b-button
      v-if="!aberto"
      variant="outline-primary"
      size="sm"
      :disabled="bloqueado"
      @click="abrir"
    >
      Corrigir dados fiscais: {{ produto.descricao }}
    </b-button>
    <div v-else class="bg-light border rounded p-3">
      <strong>{{ produto.descricao }} — dados fiscais</strong>
      <div v-if="carregando" class="mt-3">
        <b-spinner small /> Carregando cadastro...
      </div>
      <template v-else-if="cadastro">
        <p class="text-muted small mt-2">
          A correção será salva no cadastro deste produto.
        </p>
        <b-row>
          <b-col md="12">
            <b-form-group label="Perfil tributário">
              <VueSelect
                v-model="perfil"
                label="descricao"
                :options="perfis"
                :filterable="false"
                :disabled="bloqueado || salvando"
                placeholder="Pesquisar perfil ou manter o atual"
                @search="pesquisarPerfil"
                @input="aplicarPerfil"
              />
            </b-form-group>
          </b-col>
          <b-col v-for="campo in campos" :key="campo.chave" md="4">
            <b-form-group :label="campo.rotulo">
              <VueSelect
                v-model="form[campo.chave]"
                label="codigo"
                :options="opcoes[campo.chave]"
                :filterable="false"
                :disabled="bloqueado || salvando || herdadoDoPerfil(campo)"
                :input-id="`fiscal-${_uid}-${campo.chave}`"
                placeholder="Pesquisar código"
                @search="(busca, loading) => pesquisar(campo, busca, loading)"
                @open="pesquisar(campo, '', () => {})"
              >
                <template #option="opcao"
                  >{{ opcao.codigo }} — {{ opcao.descricao }}</template
                >
                <template #no-options>Nenhum código encontrado.</template>
              </VueSelect>
              <small v-if="herdadoDoPerfil(campo)" class="text-muted"
                >Definido pelo perfil tributário.</small
              >
            </b-form-group>
          </b-col>
        </b-row>
        <div class="d-flex flex-wrap">
          <b-button
            variant="outline-primary"
            size="sm"
            class="mr-2 mb-2"
            :disabled="bloqueado || salvando"
            @click="salvar(false)"
          >
            {{ salvando ? "Salvando..." : "Salvar correção" }}
          </b-button>
          <b-button
            variant="primary"
            size="sm"
            class="mr-2 mb-2"
            :disabled="bloqueado || salvando"
            @click="salvar(true)"
          >
            Salvar e reenviar esta pré-venda
          </b-button>
          <b-button
            variant="outline-secondary"
            size="sm"
            class="mb-2"
            :disabled="bloqueado || salvando"
            @click="aberto = false"
            >Cancelar</b-button
          >
        </div>
      </template>
      <b-alert
        v-if="erro"
        show
        variant="danger"
        class="mt-2 mb-0"
        role="alert"
        >{{ erro }}</b-alert
      >
      <b-button
        v-if="!cadastro && !carregando"
        variant="outline-secondary"
        size="sm"
        class="mt-2"
        @click="aberto = false"
        >Fechar edição</b-button
      >
      <p v-if="salvo" role="status" class="text-success mt-2 mb-0">
        Correção salva. A pré-venda pode ser reenviada.
      </p>
    </div>
  </div>
</template>

<script>
import VueSelect from "vue-select";
import { SistemaMixin } from "@/modules/Application";

const CAMPOS = [
  {
    chave: "id_ncm",
    rotulo: "NCM",
    id: "id_ncm",
    relacoes: ["ncm"],
    busca: "getNCM",
  },
  {
    chave: "id_cfop_nfce",
    rotulo: "CFOP NFC-e",
    id: "id_cfop",
    relacoes: ["cfop_nfce", "cfopNfce"],
    busca: "getCFOPByCodigo",
  },
  {
    chave: "id_cst_csosn",
    rotulo: "CST/CSOSN",
    id: "id_cst_csosn",
    relacoes: ["cst_csosn", "cstCsosn"],
    busca: "getCstCsosn",
  },
  {
    chave: "id_cfop",
    rotulo: "CFOP NF-e",
    id: "id_cfop",
    relacoes: ["cfop"],
    busca: "getCFOPByCodigo",
  },
  {
    chave: "id_cest",
    rotulo: "CEST",
    id: "id_cest",
    relacoes: ["cest"],
    busca: "getCESTByCodigo",
  },
  {
    chave: "id_cstpis",
    rotulo: "CST PIS",
    id: "id_cstpis",
    relacoes: ["cst_pis", "cstPis"],
    busca: "getCSTPISByCodigo",
  },
  {
    chave: "id_cstcofins",
    rotulo: "CST COFINS",
    id: "id_cstcofins",
    relacoes: ["cst_cofins", "cstCofins"],
    busca: "getCSTCofinsByCodigo",
  },
];

export default {
  name: "CorrecaoFiscalPreVenda",
  components: { VueSelect },
  mixins: [SistemaMixin],
  props: {
    produto: { type: Object, required: true },
    bloqueado: { type: Boolean, default: false },
  },
  data() {
    return {
      aberto: false,
      carregando: false,
      salvando: false,
      salvo: false,
      erro: "",
      cadastro: null,
      campos: CAMPOS,
      form: {},
      iniciais: {},
      opcoes: {},
      versoesBusca: {},
      perfil: null,
      perfis: [],
      versaoPerfil: 0,
    };
  },
  methods: {
    idSelecao(valor, chave) {
      if (!valor) return null;
      return valor[chave] || valor.id || null;
    },
    relacao(cadastro, campo) {
      return (
        campo.relacoes
          .map((chave) => cadastro[chave])
          .find((valor) => valor && typeof valor === "object") || null
      );
    },
    async abrir() {
      if (this.bloqueado || this.carregando) return;
      this.aberto = true;
      this.carregando = true;
      this.salvo = false;
      this.erro = "";
      this.cadastro = null;
      this.$emit("ocupado", true);
      try {
        const { data } = await this.$http.post("/produtos/find", {
          id: this.produto.id,
        });
        if (!data || Number(data.id) !== Number(this.produto.id))
          throw new Error("Cadastro do produto não encontrado.");
        this.cadastro = data;
        this.perfil =
          data.perfil_tributario ||
          data.perfilTributario ||
          (data.id_perfil_tributario
            ? { id: data.id_perfil_tributario, descricao: "Perfil atual" }
            : null);
        this.iniciais = {
          id_perfil_tributario: data.id_perfil_tributario || null,
        };
        for (const campo of this.campos) {
          const valor = this.relacao(data, campo);
          const id = data[campo.chave] || this.idSelecao(valor, campo.id);
          this.$set(
            this.form,
            campo.chave,
            valor ||
              (id
                ? {
                    [campo.id]: id,
                    codigo: String(id),
                    descricao: "Cadastro atual",
                  }
                : null)
          );
          this.iniciais[campo.chave] = id || null;
          this.$set(this.opcoes, campo.chave, valor ? [valor] : []);
        }
        this.aplicarPerfil(this.perfil);
      } catch (error) {
        this.erro =
          error?.response?.data?.msg ||
          error.message ||
          "Não foi possível carregar os dados fiscais.";
      } finally {
        this.carregando = false;
        this.$emit("ocupado", false);
      }
    },
    herdadoDoPerfil(campo) {
      return (
        campo.chave !== "id_ncm" &&
        !!this.perfil &&
        (this.perfil[campo.chave] != null || !!this.relacao(this.perfil, campo))
      );
    },
    aplicarPerfil(perfil) {
      if (!perfil) return;
      for (const campo of this.campos) {
        const relacao = this.relacao(perfil, campo);
        const id = perfil[campo.chave] || this.idSelecao(relacao, campo.id);
        const valor =
          relacao ||
          (id
            ? {
                [campo.id]: id,
                codigo: String(id),
                descricao: "Perfil tributário",
              }
            : null);
        if (valor && (campo.chave !== "id_ncm" || !this.form.id_ncm))
          this.$set(this.form, campo.chave, valor);
      }
    },
    async pesquisar(campo, busca, loading) {
      const versao = (this.versoesBusca[campo.chave] || 0) + 1;
      this.versoesBusca[campo.chave] = versao;
      loading(true);
      try {
        const opcoes = await this[campo.busca](busca);
        if (this.versoesBusca[campo.chave] === versao)
          this.$set(
            this.opcoes,
            campo.chave,
            Array.isArray(opcoes) ? opcoes : []
          );
      } catch (error) {
        this.erro =
          "Não foi possível pesquisar os códigos fiscais. Tente novamente.";
      } finally {
        loading(false);
      }
    },
    async pesquisarPerfil(busca, loading) {
      const versao = ++this.versaoPerfil;
      loading(true);
      try {
        const perfis = await this.getPerfilTributarioByDescricao(busca);
        if (versao === this.versaoPerfil)
          this.perfis = Array.isArray(perfis) ? perfis : [];
      } catch (error) {
        this.erro = "Não foi possível pesquisar os perfis tributários.";
      } finally {
        loading(false);
      }
    },
    payload() {
      const valores = {
        id_perfil_tributario: this.idSelecao(this.perfil, "id"),
      };
      for (const campo of this.campos) {
        if (!this.herdadoDoPerfil(campo))
          valores[campo.chave] = this.idSelecao(this.form[campo.chave], campo.id);
      }
      const payload = { id: this.produto.id };
      for (const [chave, valor] of Object.entries(valores)) {
        if (String(valor ?? "") !== String(this.iniciais[chave] ?? ""))
          payload[chave] = valor;
      }
      return payload;
    },
    async salvar(reenviar) {
      if (this.bloqueado || this.salvando || !this.cadastro) return;
      if (reenviar) {
        const faltantes = [];
        if (!this.idSelecao(this.form.id_ncm, "id_ncm")) faltantes.push("NCM");
        if (
          !this.idSelecao(this.form.id_cfop_nfce, "id_cfop") &&
          !this.idSelecao(this.form.id_cfop, "id_cfop")
        )
          faltantes.push("CFOP NFC-e");
        if (!this.idSelecao(this.form.id_cst_csosn, "id_cst_csosn"))
          faltantes.push("CST/CSOSN");
        if (faltantes.length) {
          this.erro = `Preencha os campos para reenviar: ${faltantes.join(
            ", "
          )}.`;
          return;
        }
      }
      this.salvando = true;
      this.erro = "";
      this.salvo = false;
      this.$emit("ocupado", true);
      let sucesso = false;
      try {
        const payload = this.payload();
        if (Object.keys(payload).length > 1) {
          const { data } = await this.$http.post(
            "/produtos/update-fiscal-pdv",
            payload
          );
          if (
            !data ||
            data.status === false ||
            Number(data.id) !== Number(this.produto.id)
          )
            throw new Error(data?.msg || "Não foi possível salvar a correção.");
          for (const [chave, valor] of Object.entries(payload))
            if (chave !== "id") this.iniciais[chave] = valor;
          this.salvo = true;
          this.$emit("salvo");
        }
        sucesso = true;
      } catch (error) {
        const validacoes = error?.response?.data?.errors;
        this.erro = validacoes
          ? Object.values(validacoes).flat().join(" ")
          : error?.response?.data?.msg ||
            error?.response?.data?.message ||
            error.message ||
            "Não foi possível salvar a correção.";
      } finally {
        this.salvando = false;
        this.$emit("ocupado", false);
      }
      if (sucesso && reenviar) this.$emit("reenviar");
    },
  },
};
</script>
